var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TrackingScreen',{ref:"trackingScreen",attrs:{"ble-id":_vm.bleId,"asset-id":_vm.assetId,"t":_vm.t}})
}
var staticRenderFns = []

export { render, staticRenderFns }